import { http } from 'http';

export default {
  processFileOffers: ({ user, description = '', fileString }) =>
    http.post('/webh/campaigns/masive/create', {
      user,
      description,
      excelFileBase64: fileString
    }),

  publisOffersMasive: data => http.post('/webh/campaigns/masive/request', data)
};
